export default __webpack_public_path__ + "static/media/MARIA PAZ PADILLA.c321239d.jpeg";